import React, { useState, forwardRef, useImperativeHandle } from "react";
import { Toast, ToastContainer } from "react-bootstrap";
const Toastmessage = forwardRef((props, ref) => {
  const [showToast, setToast] = useState(false);
  const [position, setPosition] = useState("top-center");
  const [msg, setMsg] = useState(false);
  const [msgtype, setMsgtype] = useState(false);

  useImperativeHandle(ref, () => ({
    toastlog(msgtype, msg) {
      console.log(msg);
      setMsg(msg);
      setMsgtype(msgtype);
      setToast(true);
    },
  }));
  return (
    <div
      style={{
        position: "fixed",
        zIndex: 9999,
        width: "100%",
        top: 50,
        left: 0,
      }}
    >
      <ToastContainer className="p-3 '" position={position}>
        <Toast
          onClose={() => setToast(false)}
          autohide
          show={showToast}
          delay={2200}
          className="bg-white border-0 rounded-0 "
        >
          <Toast.Header className="border-0" closeButton={false}>
            <strong className="me-auto">Alert</strong>
            {/*  <small>50 mins ago</small> */}
            <a
              className="btn btn-link btn-sm text-decoration-none"
              onClick={() => setToast(false)}
            >
              Close
            </a>
          </Toast.Header>
          <Toast.Body className="pb-4 ">
            {msgtype ? (
              <div style={{ fontSize: 15 }} className="text-success">
                {/* <i className="fa fa-check-circle-o" aria-hidden="true"></i>&nbsp;&nbsp; */}
                {msg}
              </div>
            ) : (
              <div style={{ fontSize: 15 }} className="text-danger">
                {/* <i className="fa fa-exclamation-circle" aria-hidden="true"></i>&nbsp;&nbsp; */}
                {msg}
              </div>
            )}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
});

export default Toastmessage;
